import { Anchor, Flex, rem, rgba, Text } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { LoginForm as LoginFormType } from "../../hooks/useLoginController";
import { FormTextInput } from "@/design-system/components/form/FormTextInput";
import { FormPasswordInput } from "@/design-system/components/form/FormPasswordInput";
import { Link } from "react-router-dom";

interface LoginFormProps {
  form: UseFormReturnType<LoginFormType>;
  onSubmit: () => void;
  credentialsErrorActive: boolean;
  credentialsErrorMessage: string;
  onCredentialsInteraction: () => void;
  formId: string;
}

export const LoginForm = ({
  form,
  onSubmit,
  credentialsErrorActive,
  credentialsErrorMessage,
  onCredentialsInteraction,
  formId,
}: LoginFormProps) => {
  const emailInputProps = form.getInputProps("email");
  const passwordInputProps = form.getInputProps("password");

  const passwordShowsCredentialsError =
    credentialsErrorActive &&
    passwordInputProps.error === credentialsErrorMessage;

  return (
    <form
      id={formId}
      onSubmit={form.onSubmit(onSubmit)}
      style={{ width: "100%" }}>
      <FormTextInput
        type="email"
        label="E-mail"
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite seu e-mail..."
        size="md"
        required
        withAsterisk={false}
        withErrorStyles={false}
        styles={{ input: { border: "none" } }}
        {...emailInputProps}
        onChange={(event) => {
          onCredentialsInteraction();
          emailInputProps.onChange(event);
        }}
        forceErrorState={credentialsErrorActive}
      />
      <FormPasswordInput
        label={<PasswordInputLabel />}
        c={rgba("var(--mantine-color-plain_text-0)", 0.5)}
        placeholder="Digite sua senha..."
        size="md"
        styles={{
          input: { border: "none" },
          label: {
            width: "100%",
            marginBottom: rem(4),
          },
        }}
        required
        withAsterisk={false}
        withErrorStyles={false}
        {...passwordInputProps}
        onChange={(event) => {
          onCredentialsInteraction();
          passwordInputProps.onChange(event);
        }}
        forceErrorState={credentialsErrorActive}
        error={
          passwordShowsCredentialsError
            ? credentialsErrorMessage
            : passwordInputProps.error
        }
      />
    </form>
  );

  function PasswordInputLabel() {
    return (
      <Flex
        direction={"row"}
        w={"100%"}
        justify={"space-between"}
        align={"center"}>
        <Text
          component="span"
          fw={"inherit"}>
          Senha
        </Text>
        <Anchor
          component={Link}
          to={"/forgot-password"}
          c={"var(--mantine-color-R500-0)"}
          fw={700}
          td={"underline"}>
          Esqueci minha senha
        </Anchor>
      </Flex>
    );
  }
};
